import React, {
  createContext, useCallback, useContext, useState,
} from 'react';

import { SH_SPRING_ID, SH_SESSION_ID } from '@/utils/springHealthUtils';

export type SpringIdContextType = {
  springId: string | undefined;
  sessionId: string | undefined;
  setSpringId: (id: string | undefined) => void;
  setSessionId: (id: string | undefined) => void;
};

const SpringIdContext = createContext<SpringIdContextType>(undefined);

export const SpringIdProvider = ({ children }: { children: React.ReactNode }) => {
  const [springId, setSpringIdState] = useState<string | undefined>(
    () => sessionStorage.getItem(SH_SPRING_ID) || undefined,
  );
  const [sessionId, setSessionIdState] = useState<string | undefined>(
    () => sessionStorage.getItem(SH_SESSION_ID) || undefined,
  );

  const setSpringId = useCallback((id: string | undefined) => {
    setSpringIdState(id);
    if (id) {
      sessionStorage.setItem(SH_SPRING_ID, id);
    } else {
      sessionStorage.removeItem(SH_SPRING_ID);
    }
  }, []);

  const setSessionId = useCallback((id: string | undefined) => {
    setSessionIdState(id);
    if (id) {
      sessionStorage.setItem(SH_SESSION_ID, id);
    } else {
      sessionStorage.removeItem(SH_SESSION_ID);
    }
  }, []);

  return (
    <SpringIdContext.Provider value={{
      springId, sessionId, setSpringId, setSessionId,
    }}
    >
      {children}
    </SpringIdContext.Provider>
  );
};

export const useSpringId = () => useContext(SpringIdContext);
